import React, {Component} from 'react';
import AdminHomeTableRowMessage from './admin-home-table-row-message';

class AdminHomeTableMessages extends Component{

    

    render(){

        return(
           <div className="tab-pane fade" id="messages" role="tabpanel">
                 <div className="text-center">
                    <a className="export-all-btn red-btn" href="/adminhome">تصدير كل الرسائل</a>
                </div>
               <div className="users-table-admin">
               
                <table className="table users-table-admin table-responsive-md">
                        <thead>
                            <tr>
                                <th>الاسم</th>
                                <th>رقم الجوال </th>
                                <th>اسم الشركة </th>
                                <th>البريد الالكتروني</th>
                                <th>نص الرسالة</th>
                                <th>المهام</th>
                            </tr>
                        </thead>
                        <tbody>
                                <AdminHomeTableRowMessage  userName={"أحمد محمد البنا"} userPhoneNo={"01120303508"} companyName={"CRETE Agency"} userMail={"bana@creteagency.com"}  userMessage={"أهلا بك في كساندرا"}/>
                        </tbody>
                    </table>
                </div>
            </div>
                        
            
        );
       
    }

};
export default AdminHomeTableMessages;


